import axios from "axios";
import { BASE_PATH } from "./commonApi";
import { useParams } from "react-router-dom";
import { langCodeState } from "recoil/commonUiAtom";
import { useRecoilValue } from "recoil";
import { useInfiniteQuery } from "react-query";

export const useInfiniteScrollQuery = () => {
  const { profilekey } = useParams();
  const langCode = useRecoilValue(langCodeState);

  const getLikePosts = async ({ pageParam = 1 }) => {
    const res = await axios.get(
      `${BASE_PATH}/api/vfunlounge/profile/user_like_list/${profilekey}?lang=${langCode}&type=posts&page=${pageParam}`
    );

    return {
      result: res.data.result,
      boardpage: res.data.result === 1 ? res.data.data.data : "",
      currentpage: res.data.result === 1 ? res.data.data.current_page : 0,
      total: res.data.result === 1 ? res.data.data.total : 0,
      isLast:
        res.data.result === 1
          ? res.data.data.current_page === res.data.data.last_page
            ? true
            : false
          : false
    };
  };

  const {
    data: getBoard,
    fetchNextPage: getNextPage,
    isSuccess: getBoardIsSuccess,
    hasNextPage: getNextPageIsPossible
  } = useInfiniteQuery(["like-posts", langCode], getLikePosts, {
    getNextPageParam: (lastPage, pages) => {
      if (!lastPage.isLast) {
        return lastPage.currentpage + 1;
      }
      return undefined;
    }
  });

  return { getBoard, getNextPage, getBoardIsSuccess, getNextPageIsPossible };
};
